import { render, staticRenderFns } from "./zqjcpsForm.vue?vue&type=template&id=25dbe823&scoped=true&"
import script from "./zqjcpsForm.vue?vue&type=script&lang=js&"
export * from "./zqjcpsForm.vue?vue&type=script&lang=js&"
import style0 from "./zqjcpsForm.vue?vue&type=style&index=0&id=25dbe823&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25dbe823",
  null
  
)

export default component.exports